<template>
  <li class="app-list-item-divider"></li>
</template>

<script>
export default {
  name: 'AppListItemDivider',
}
</script>

<style lang="scss" scoped>
.app-list-item-divider {
  background-color: rgba(0, 0, 0, 0.2);
  height: 1px;
  margin: 0;
  padding: 0;
}
</style>
